<template>
  <div class="register-container">
    <div class="register-box">
      <h2>客户注册</h2>
      <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="register-form" @keyup.enter.native="handleRegister">
        <el-form-item prop="companyName">
          <el-input 
            v-model="registerForm.companyName" 
            prefix-icon="el-icon-office-building" 
            placeholder="请输入单位名称"
            @keyup.enter.native="handleRegister">
          </el-input>
        </el-form-item>
        <el-form-item prop="contactPerson">
          <el-input 
            v-model="registerForm.contactPerson" 
            prefix-icon="el-icon-user" 
            placeholder="请输入联系人"
            @keyup.enter.native="handleRegister">
          </el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input 
            v-model="registerForm.phone" 
            prefix-icon="el-icon-phone" 
            placeholder="请输入联系方式" 
            @keyup.enter.native="handleRegister">
          </el-input>
        </el-form-item>
        <el-form-item prop="address">
          <el-input 
            v-model="registerForm.address" 
            prefix-icon="el-icon-location" 
            type="textarea"
            placeholder="请输入地址" 
            @keyup.enter.native="handleRegister">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="registerForm.password" 
            prefix-icon="el-icon-lock" 
            placeholder="请输入密码" 
            show-password
            @keyup.enter.native="handleRegister">
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input 
            v-model="registerForm.confirmPassword" 
            prefix-icon="el-icon-lock" 
            placeholder="请确认密码" 
            show-password
            @keyup.enter.native="handleRegister">
          </el-input>
        </el-form-item>
        <el-form-item prop="registerCode">
          <el-input 
            v-model="registerForm.registerCode" 
            prefix-icon="el-icon-key" 
            placeholder="请输入注册码"
            @keyup.enter.native="handleRegister">
          </el-input>
        </el-form-item>
        <el-form-item prop="agreement">
          <el-checkbox v-model="registerForm.agreement">
            我已阅读并同意
            <span v-if="agreementList && agreementList.length > 0">
              <span v-for="(agreement, index) in agreementList" :key="agreement.id">
                <el-button type="text" @click="showSpecificAgreement(agreement.id)">
                  《{{agreement.title}}》
                </el-button>
                <span v-if="index < agreementList.length - 1">、</span>
              </span>
            </span>
            <el-button v-else type="text" @click="showAgreement">《协议加载中...》</el-button>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button 
            :loading="loading" 
            type="warning" 
            class="register-button" 
            @click="handleRegister">
            注册
          </el-button>
        </el-form-item>
      </el-form>
      <div class="login-link">
        已有账号？<el-link type="primary" @click="goToLogin">立即登录</el-link>
      </div>
      <div class="back-home">
        <el-link type="primary" @click="goHome">返回首页</el-link>
      </div>
    </div>

    <!-- 所有协议对话框 -->
    <el-dialog
      title="客户协议"
      :visible.sync="allAgreementsDialogVisible"
      width="70%">
      <div v-loading="agreementLoading">
        <!-- 没有协议时显示提示 -->
        <div v-if="!agreementLoading && (!agreementList || agreementList.length === 0)" class="no-agreement">
          暂无协议内容
        </div>
        
        <!-- 有协议时显示标签页 -->
        <el-tabs v-if="agreementList && agreementList.length > 0" v-model="activeAgreementTab" type="card">
          <el-tab-pane 
            v-for="agreement in agreementList" 
            :key="agreement.id" 
            :label="agreement.title" 
            :name="agreement.id.toString()">
            <div class="agreement-content">
              <h3>{{agreement.title}}</h3>
              <div v-html="agreement.content"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer text-center">
        <el-button type="primary" @click="agreeToTerms">我已阅读并同意</el-button>
      </span>
    </el-dialog>

    <!-- 单个协议对话框 -->
    <el-dialog
      :title="currentAgreement ? currentAgreement.title : '客户协议'"
      :visible.sync="singleAgreementDialogVisible"
      width="70%">
      <div v-loading="singleAgreementLoading">
        <div v-if="currentAgreement" class="agreement-content">
          <div v-html="currentAgreement.content"></div>
        </div>
        <div v-else-if="!singleAgreementLoading" class="no-agreement">
          暂无协议内容
        </div>
      </div>
      <span slot="footer" class="dialog-footer text-center">
        <el-button type="primary" @click="agreeToTermsFromSingle">我已阅读并同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import adminApi from '../../api/adminApi'

export default {
  name: 'CustomerRegister',
  data() {
    // 密码一致性校验
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      registerForm: {
        companyName: '',
        contactPerson: '',
        phone: '',
        address: '',
        registerCode: '',
        password: '',
        confirmPassword: '',
        agreement: false
      },
      registerRules: {
        companyName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        registerCode: [
          { required: true, message: '请输入注册码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ],
        agreement: [
          { validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请阅读并同意所有协议'))
            }
          }, trigger: 'change' }
        ]
      },
      loading: false,
      agreementLoading: false,
      singleAgreementLoading: false,
      agreementList: [],
      activeAgreementTab: '1', // 默认选中第一个标签
      pagination: {
        current: 1,
        size: 50,  // 获取较多协议以确保获取全部
        total: 0
      },
      allAgreementsDialogVisible: false,
      singleAgreementDialogVisible: false,
      currentAgreement: null
    }
  },
  methods: {
    handleRegister() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          if (!this.registerForm.agreement) {
            this.$message.warning('请阅读并同意所有协议')
            return false
          }
          
          this.loading = true
          // 构建注册数据，移除确认密码字段和协议同意字段
          const registerData = { ...this.registerForm }
          delete registerData.confirmPassword
          delete registerData.agreement
          
          // 调用注册API
          adminApi.createCustomer(registerData)
            .then(res => {
              this.$message.success('注册成功，请登录')
              // 注册成功后跳转到登录页
              this.$router.push('/customer/login')
            })
            .catch(err => {
              this.$message.error(err.message || '注册失败，请稍后重试')
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    showAgreement() {
      this.allAgreementsDialogVisible = true
      this.loadAgreements()
    },
    showAllAgreements() {
      // 关闭单个协议对话框，打开所有协议对话框
      this.singleAgreementDialogVisible = false
      this.allAgreementsDialogVisible = true
      this.loadAgreements()
    },
    showSpecificAgreement(agreementId) {
      // 加载单个协议并显示
      this.singleAgreementLoading = true
      this.singleAgreementDialogVisible = true
      
      // 首先尝试从已加载的协议列表中查找
      if (this.agreementList && this.agreementList.length > 0) {
        const agreement = this.agreementList.find(a => a.id === agreementId)
        if (agreement) {
          this.currentAgreement = agreement
          this.singleAgreementLoading = false
          return
        }
      }
      
      // 如果没有找到或列表为空，则单独加载该协议
      adminApi.getAgreementById(agreementId)
        .then(res => {
          this.currentAgreement = res
        })
        .catch(err => {
          this.$message.error('获取协议内容失败：' + (err.message || '未知错误'))
          console.error('获取协议失败:', err)
        })
        .finally(() => {
          this.singleAgreementLoading = false
        })
    },
    loadAgreements() {
      if (this.agreementList.length === 0) {
        this.agreementLoading = true
        // 使用分页接口获取所有协议
        adminApi.getAgreementListByPage({
          current: this.pagination.current,
          size: this.pagination.size
        })
          .then(res => {
            if (res && res.data) {
              this.agreementList = res.data.data.list || []
              this.pagination.total = res.data.data.total || 0
              
              // 如果有协议，默认选中第一个
              if (this.agreementList.length > 0) {
                this.activeAgreementTab = this.agreementList[0].id.toString()
              }
            }
          })
          .catch(err => {
            this.$message.error('获取协议内容失败：' + (err.message || '未知错误'))
            console.error('获取协议列表失败:', err)
          })
          .finally(() => {
            this.agreementLoading = false
          })
      }
    },
    agreeToTerms() {
      this.registerForm.agreement = true
      this.allAgreementsDialogVisible = false
    },
    agreeToTermsFromSingle() {
      this.registerForm.agreement = true
      this.singleAgreementDialogVisible = false
    },
    goToLogin() {
      this.$router.push('/customer/login')
    },
    goHome() {
      this.$router.push('/')
    }
  },
  created() {
    // 在组件创建时预加载协议内容
    this.loadAgreements()
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  padding: 20px 0;
}
.register-box {
  width: 450px;
  padding: 30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.register-box h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #E6A23C;
}
.register-button {
  width: 100%;
}
.login-link {
  text-align: center;
  margin-top: 15px;
}
.back-home {
  text-align: center;
  margin-top: 20px;
}
/* 修复文本域字体样式 */
::v-deep .el-textarea__inner {
  font-family: inherit;
  font-size: inherit;
}
/* 协议内容样式 */
.agreement-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 10px;
  min-height: 200px;
}
.agreement-content h3 {
  text-align: center;
  margin-bottom: 20px;
}
.no-agreement {
  text-align: center;
  color: #909399;
  margin-top: 80px;
  margin-bottom: 80px;
}
.text-center {
  text-align: center;
  display: block;
}
</style> 